const fillOutboundSegment = (value, searchSegments, matchResult) => {
    searchSegments[0] = checkSegmentAndExtendWithProperty('from', value, matchResult[3], searchSegments[0]);
    searchSegments[1] = checkSegmentAndExtendWithProperty('to', value, matchResult[3], searchSegments[1]);
    return searchSegments;
};

const fillReturnSegment = (value, searchSegments, matchResult) => {
    searchSegments[1] = checkSegmentAndExtendWithProperty('from', value, matchResult[3], searchSegments[1]);
    searchSegments[0] = checkSegmentAndExtendWithProperty('to', value, matchResult[3], searchSegments[0]);
    return searchSegments;
};

const fillDateSegmentForDeparture = (value, searchSegments, matchResult) => {
    searchSegments[0] = checkSegmentAndExtendWithProperty('dep', value, matchResult[3], searchSegments[0]);
    return searchSegments;
};

const fillDateSegmentForReturn = (value, searchSegments, matchResult) => {
    searchSegments[1] = checkSegmentAndExtendWithProperty('ret', value, matchResult[3], searchSegments[1]);
    return searchSegments;
};

const checkSegmentAndExtendWithProperty = (originPropName, propValue, propName, currentSegment) => {
    currentSegment = currentSegment || {};
    Odigeo._.extend(currentSegment, getSegmentProperty(originPropName, propValue, propName, currentSegment));
    return currentSegment;
};

const fillSegmentWithMatchedValues = (value, searchSegments, matchResult) => {
    const segmentId = matchResult[2] || 0;
    searchSegments[segmentId] = searchSegments[segmentId] || {};
    Odigeo._.extend(searchSegments[segmentId], getSegmentProperty(matchResult[1], value, matchResult[4], searchSegments[segmentId]));
    return searchSegments;
};

const getSegmentProperty = (type, value, key, segment) => {
    let location;

    switch (type) {
        case 'from':
        case 'to':
            location = segment[SEARCH.SEGMENT_KEY_MAP[type]] || {};
            if (!key) {
                if (value.match(/^\d+$/)) {
                    location.geoNodeId = value;
                } else {
                    location.iata = value;
                }
            } else {
                if (key === 'id') {
                    key = 'geoNodeId';
                }
                location[key] = value;
            }
            segment[SEARCH.SEGMENT_KEY_MAP[type]] = location;
            break;
        case 'dep':
        case 'ret':
            if (key) {
                segment[SEARCH.SEGMENT_KEY_MAP[key]] = value;
            } else {
                segment.dateStr = value;
            }
            break;
    }

    return segment;
};

const fillSegmentParametrizedDatesForDeparture = (value, searchSegments) => {
    const initDate = searchSegments[0].dateStr ? searchSegments[0].dateStr : '';
    Odigeo._.extend(searchSegments[0], fillSegmentParametrizedDates('dep', value, searchSegments[0], initDate));
    return searchSegments;
};

const fillSegmentParametrizedDatesForReturn = (value, searchSegments) => {
    const initDate = searchSegments[0].dateStr ? searchSegments[0].dateStr : '';
    Odigeo._.extend(searchSegments[1], fillSegmentParametrizedDates('ret', value, searchSegments[1], initDate));
    return searchSegments;
};

const fillSegmentParametrizedDates = (type, value, segment, initDate) => {
    return getSegmentProperty(type, composeParametrizedDate(type, value, initDate), null, segment);
};

const composeParametrizedDate = (type, value, depDate) => {
    if (!Odigeo._.isNull(depDate) || type === 'dep') {
        let date;
        let datePlusOffset;
        let splitDate;
        const formatDate = function(date) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
        };

        if (type === 'dep') {
            date = new Date();
        } else {
            splitDate = depDate.split('-');
            date = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
        }

        datePlusOffset = date.getDate() + parseInt(value, 10);
        date.setDate(datePlusOffset);
        return formatDate(date);
    }
};

const getBooleanOrValueType = (paramValue) => {
    let value;

    switch (paramValue) {
        case '':
        case 'false':
            value = false;
            break;
        case 'true':
            value = true;
            break;
        default:
            value = paramValue;
    }
    return value;
};

const getQuantityType = (paramValue) => {
    const value = parseInt(paramValue, 10);
    if (!Odigeo._.isNaN(value)) {
        return value;
    }
};

const getListOfValuesType = (paramValue) => {
    switch (paramValue) {
        case '':
        case 'false':
            break;
        default:
            return paramValue.split(',');
    }
};

const SEARCH = {
    DEFAULT: {
        'cabinClass': 'TOURIST',
        'directFlightsOnly': false,
        'numAdults': 1,
        'numChildren': 0,
        'numInfants': 0,
    },
    PARAMS_PARSER: {
        'class': 'cabinClass',
        'direct': 'directFlightsOnly',
        'trainSearch': 'trainSearch',
        'resident': 'resident',
        'adults': 'numAdults',
        'children': 'numChildren',
        'infants': 'numInfants',
        'kid0Age': 'kid0Age',
        'kid1Age': 'kid1Age',
        'kid2Age': 'kid2Age',
        'kid3Age': 'kid3Age',
        'kid4Age': 'kid4Age',
        'kid5Age': 'kid5Age',
        'infant0Age': 'infant0Age',
        'infant1Age': 'infant1Age',
        'infant2Age': 'infant2Age',
        'infant3Age': 'infant3Age',
        'collectionmethod': 'collectionMethod',
        'airlinescodes': 'airlinesCodes',
        'fareItineraryKey': 'fareItineraryKey',
        'searchId': 'searchId',
        'buyPath': 'buyPath',
        'internalSearch': 'internalSearch',
        'landingPageType': 'landingPageType',
        'flexibleDates': 'flexibleDates',
        'mainairports': 'mainAirportsOnly',
    },
    MAPI_PARAMS: {
        regex: /^(segmentKey)(\d+)?(\.([a-zA-Z]+))?$/,
    },
    PARAMS_STRINGIFY: {
        type: 'type',
        searchSegments: 'searchSegments',
        directFlightsOnly: 'direct',
        trainSearch: 'trainSearch',
        resident: 'resident',
        cabinClass: 'class',
        numAdults: 'adults',
        numChildren: 'children',
        numInfants: 'infants',
        kid0Age: 'kid0Age',
        kid1Age: 'kid1Age',
        kid2Age: 'kid2Age',
        kid3Age: 'kid3Age',
        kid4Age: 'kid4Age',
        kid5Age: 'kid5Age',
        infant0Age: 'infant0Age',
        infant1Age: 'infant1Age',
        infant2Age: 'infant2Age',
        infant3Age: 'infant3Age',
        collectionMethod: 'collectionmethod',
        airlinesCodes: 'airlinescodes',
        internalSearch: 'internalSearch',
        flexibleDates: 'flexibleDates',
        mainAirportsOnly: 'mainairports',
    },
    STRINGIFY_DATES_VALUES: {
        dep: 'dep',
        ret: 'ret',
        from: 'from',
        to: 'to',
        time: '.time',
        timeWindow: '.timewindow',
    },
    TYPES: {
        'O': 'oneWayTrip',
        'R': 'roundTrip',
        'M': 'multipleTrip',
    },
    SEGMENT_KEY_MAP: {
        'from': 'departure',
        'to': 'destination',
        'timewindow': 'timeWindow',
        'time': 'time',
    },
    AGE_SELECTOR: {
        'kid0Age': 0,
        'kid1Age': 0,
        'kid2Age': 0,
        'kid3Age': 0,
        'kid4Age': 0,
        'kid5Age': 0,
        'infant0Age': 0,
        'infant1Age': 0,
        'infant2Age': 0,
        'infant3Age': 0,
    },
    PARAMS_FORMATTER_FUNCTIONS: {
        'resident': getBooleanOrValueType,
        'direct': getBooleanOrValueType,
        'trainSearch': getBooleanOrValueType,
        'buyPath': getBooleanOrValueType,
        'landingPageType': getBooleanOrValueType,
        'internalSearch': getBooleanOrValueType,
        'mainairports': getBooleanOrValueType,
        'flexibleDates': (paramValue) => paramValue === 'true',
        'kid0Age': getQuantityType,
        'kid1Age': getQuantityType,
        'kid2Age': getQuantityType,
        'kid3Age': getQuantityType,
        'kid4Age': getQuantityType,
        'kid5Age': getQuantityType,
        'infant0Age': getQuantityType,
        'infant1Age': getQuantityType,
        'infant2Age': getQuantityType,
        'infant3Age': getQuantityType,
        'adults': getQuantityType,
        'children': getQuantityType,
        'infants': getQuantityType,
        'collectionmethod': getQuantityType,
        'airlinescodes': getListOfValuesType,
        'class': Odigeo._.identity,
    },
    SEGMENTS_FORMATTER_FUNCTIONS: {
        'oneWayTrip': {
            regex: /^(from|to|dep|X)(\d+)?(\.([a-zA-Z]+))?$/,
            cases: {
                'X': fillSegmentParametrizedDatesForDeparture,
                'defaultParser': fillSegmentWithMatchedValues,
            },
        },
        'multipleTrip': {
            regex: /^(from|to|dep)(\d+)?(\.([a-zA-Z]+))?$/,
            cases: {
                'defaultParser': fillSegmentWithMatchedValues,
            },
        },
        'roundTrip': {
            regex: /^(from|to|dep|ret|X|Y)(\.([a-zA-Z]+))?$/,
            cases: {
                'from': fillOutboundSegment,
                'to': fillReturnSegment,
                'dep': fillDateSegmentForDeparture,
                'ret': fillDateSegmentForReturn,
                'X': fillSegmentParametrizedDatesForDeparture,
                'Y': fillSegmentParametrizedDatesForReturn,
            },
        },
    },
};

module.exports = SEARCH;
